import {Injectable} from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';

import {Observable} from 'rxjs';
import {tap} from "rxjs/operators";
import {TokenService} from "../services/token.service";

@Injectable()
export class AuthenticationTokenInterceptor implements HttpInterceptor {


    constructor(private tokenService : TokenService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler):
        Observable<HttpEvent<any>> {

        const authToken = this.tokenService.getToken() || '';
        console.debug('Token used');
        const tokenRequest = req.clone({
            setHeaders: {
                'X-AUTH-TOKEN': authToken
            }
        });

        return next.handle(tokenRequest).pipe(tap((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                console.debug('Token received', event.headers.get('x-auth-token'));
                this.tokenService.storeToken(event.headers.get('x-auth-token'));
            }
        }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401) {
                    console.log('401 ');
                    // redirect to the login route
                    // or show a modal
                } else if(err.status === 500){
                    console.log('500 ', err);
                }
            }
        }));
    }
}